
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ContentSystemMessagingModel = require("content-models/system-messaging/ContentSystemMessagingModel");
    var TabsBar = require("ui/tabsbar/TabsBar");
    var Button = require("ui/button/Button");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var HotKeysCollection = require("content-collections/HotKeysCollection");
    var Constant = require("content-config/constant.json");

    var ContentSystemMessagingEditPageModel = {};

    //list of keys on the Content JSON instead of repeating strings everywhere
    var KEYS = {
        model: "model",
        type: "type",
        languageTabCollection: "languageTabCollection",
        skillTabCollection: "skillTabCollection",
        editType: "editType",
        header: "header",
        pageInfo: "pageInfo",
        pageInfoTotals: "pageInfo.totalPages",
        pageInfoCurrent: "pageInfo.currentPageNumber",
        pageInfoPrevious: "pageInfo.previousPageNumber",
        saveAllowed: "save.allowed",
        contentModelHasChanges: "save.modelChanged",
        saveAllowedTooltipKey: "save.tooltipKey",
        saveAllowedTooltipValue: "save.tooltipValue",
        addLanguagesButton: "addLanguages",
        addSkillsButton: "addSkills",
        allowMiniErrors: "allowMiniErrors",
        inUseHotKeysCollection: "inUseHotKeysCollection"
    };
    var CONTEXTS = {
        ACCOUNT: "ACCOUNT",
        SKILL: "SKILL"
    };
    var DEFAULT_SKILL_NAME = "all";
    var TYPES = Constant.CONTENT_TYPES;

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemMessagingEditPageModel = BaseModel.extend({
            languageContentMap: {},
            name: "ContentSystemMessagingEditPageModel",
            defaults: {
                model: null,
                type:  TYPES.SYSTEM_MESSAGING,
                languageTabCollection: null ,
                skillTabCollection: null ,
                header: {
                    title: "",
                    description: ""
                },
                pageInfo: {
                    previousPageNumber : 0,
                    currentPageNumber: 0,
                    totalPages: 1
                },
                save:{
                    allowed: false,
                    modelChanged:false,
                    tooltipKey: "",
                    tooltipValue: ""
                }
            },

            initialize: function (options) {
                this.onClearEmptySystemMessagingModel = new ContentSystemMessagingModel();
                this.set(KEYS.model,this.onClearEmptySystemMessagingModel);
                this.set(KEYS.languageTabCollection,SelectableCollectionDecorator.decorate(new TabsBar.TabCollection()));
                this.set(KEYS.skillTabCollection,SelectableCollectionDecorator.decorate(new TabsBar.TabCollection()));
            },
            getModelData: function (){
                return this.getContentModel().getData();
            },
            setModelData: function(data, options){
                this.getContentModel().setData(data, options);
                _.each(this.languageCodes, function (lang, index, list) {
                    this._setHasContentFlagOnTab(lang);
                },this);
            },
            clear: function() {
                this.setSelectedLanguage(this.defaultSiteLang);
                this.setContentModel(this.onClearEmptySystemMessagingModel);
            },
            isContentEmpty: function(){
                return this.getContentModel() === this.onClearEmptySystemMessagingModel;
            },
            getTranslatedLanguagesWithErrors: function() {
                var languagesWithErrors = this.getContentModel().getLanguagesWithErrors();
                var languageNamesTranslated = LE.siteSettings.supportedLanguageSettings.getAllLanguageNamesTranslated();
                var translatedLanguagesWithErrors = _.map(languagesWithErrors, function(landCode) {
                    return languageNamesTranslated[landCode];
                });
                return translatedLanguagesWithErrors;
            },
            initLanguageTabs: function(){
                this.defaultSiteLang = LE.siteSettings.supportedLanguageSettings.getDefaultLanguage();
                this.languageCodes = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var languageNamesTranslated = LE.siteSettings.supportedLanguageSettings.getAllLanguageNamesTranslated();
                var selectedLanguage = this.getSelectedLanguage();
                if(_.isUndefined(selectedLanguage)){
                    selectedLanguage = this.defaultSiteLang;
                }

                LEContent.logger.debug("Initializing languages","ContentSystemMessagingEditPageModel:initLanguageTabs");
                //Prepare the language tab array
                this.languageCodes = _.sortBy(this.languageCodes, function(languageCode){
                    return languageCode != this.defaultSiteLang;
                }, this);

                var languageTabs = {};

                if (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_SYSTEM_MESSAGES)) {//TODO ivanm change it to messaging
                    languageTabs[KEYS.addLanguagesButton] = this._createTabBar({
                        id: KEYS.addLanguagesButton,
                        tooltip: LE.translator.translate("LEContent.content.edit.add.languages.tab.tooltip"),
                        isButton: true
                    });
                }

                _.each(this.languageCodes, function (code, index, list) {
                    languageTabs[code] = this._createTabBar({id: code, name: languageNamesTranslated[code], hasContent: this.getContentModel().hasContent(code)});
                }, this);

                LEContent.logger.debug("instance tabs value","ContentSystemMessagingEditPageModel:initInstances",languageTabs);
                this.getLanguageTabCollection().reset(_.values(languageTabs));
                if(!languageTabs[selectedLanguage]) {
                    selectedLanguage = this.defaultSiteLang;
                }
                this.setSelectedLanguage(selectedLanguage);

            },

            initSkillTabs: function(modelAll, selectedSkillId, selectedLanguageId, newAssignSkills){
                LEContent.logger.debug("Initializing languages","ContentSystemMessagingEditPageModel:initLanguageTabs");
                var skillTabs = [];
                var skillsCollection = LEContent.getDataManager().getSkillsCollection();
                var buttonPlusOptions = this._getAddSkillButtonOptions(modelAll, skillsCollection, newAssignSkills);
                skillTabs.push(this._createTabBar(buttonPlusOptions));
                var skillsCounter = this._getSkillsCounter(modelAll, newAssignSkills);
                var allSkillsTabTooltip = LE.translator.translate("LEContent.content.edit.all.skills.tab.tooltip");
                if(skillsCounter) {
                    allSkillsTabTooltip = LE.translator.translate("LEContent.content.edit.remaining.skills.tab.tooltip");
                }
                skillTabs.push(this._createTabBar({id: DEFAULT_SKILL_NAME, name: "", hasContent: true, className: "tab-all", tooltip: allSkillsTabTooltip}));

                _.each(modelAll.getContextSkill(), function (code, index, list) {
                    //return tabs map
                    if(skillsCollection) {
                        var skillModel = skillsCollection.get(index);
                        if(skillModel) {
                            var existsSkillsOptions = this._getExistsSkillsOptions(skillModel, code, index);
                            skillTabs.push(this._createTabBar(existsSkillsOptions));
                        }
                    }
                }, this);

                _.each(newAssignSkills, function (code, index, list) {
                    //return tabs map
                    if(skillsCollection) {
                        var skillModel = skillsCollection.get(code);
                        if(skillModel) {
                            var newSkillsOptions = this._getNewSkillsOptions(skillModel, code);
                            skillTabs.push(this._createTabBar(newSkillsOptions));
                        }
                    }
                }, this);

                var skillTabsSorted = _.sortBy(skillTabs, function(skill) {
                    return skill.get("name");
                });

                LEContent.logger.debug("instance tabs value","ContentSystemMessagingEditPageModel:initInstances",skillTabsSorted);
                this.getSkillTabCollection().reset(skillTabsSorted);

                if(selectedSkillId && this.getSkillTabCollection() && this.getSkillTabCollection().get(selectedSkillId)) {
                    this.setSelectedSkill(selectedSkillId);
                } else {
                    this.setSelectedSkill(DEFAULT_SKILL_NAME);
                }

                if(selectedLanguageId) {
                    this.setSelectedLanguage(selectedLanguageId);
                }
            },

            _createTabBar: function(options) {
                options = options || {};
                options.align = options.align || "right";
                options.hasCheckbox = options.hasCheckbox || false;
                options.hasContent = options.hasContent || false;
                if(options.isButton) {
                    options.btnPermutation = Button.PERMUTATION.BTN_PLUS;
                }
                return new TabsBar.TabModel(options);
            },

            _getAddSkillButtonOptions: function(modelAll, skillsCollection, newAssignSkills) {
                var skillsCounter = this._getSkillsCounter(modelAll, newAssignSkills);
                var btnState = Button.STATES.ENABLED;
                var btnTooltip = LE.translator.translate("LEContent.content.edit.add.skill.tab.tooltip");
                if(skillsCollection && newAssignSkills && skillsCounter === skillsCollection.size()) {
                    btnState = Button.STATES.DISABLED;
                    btnTooltip = LE.translator.translate("LEContent.content.gallery.system.button.disabled");
                }
                return {id: KEYS.addSkillsButton, btnState: btnState, tooltip: btnTooltip, isButton: true};
            },
            _getSkillsCounter: function(modelAll, newAssignSkills) {
                return Object.keys(modelAll.getContextSkill()).length + newAssignSkills.length;
            },
            _getExistsSkillsOptions: function(skillModel, code, index) {
                var name = skillModel.get("name");
                return {id: index, name: name, hasContent: code.data ? true : false, className: "skillEllipsis", isEllipsis: true, align: "center"};
            },
            _getNewSkillsOptions: function(skillModel, code) {
                var name = skillModel.get("name");
                return {id: code, name: name, className: "skillEllipsis", isEllipsis: true, align: "center"};
            },
            /**
             * Find which languages has been added to the account supported languages - since the last time the tabs were initialized
             * @returns {Array}
             */
            getAddedLanguageCodes: function(){
                var siteLanguages = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var tabLanguages = this.getLanguageTabCollection().pluck("id");
                var missingLanguageCodes = [];

                _.each(siteLanguages, function (code, index, list){
                    if(!_.contains(tabLanguages, code)){
                        missingLanguageCodes.push(code);
                    }
                }, this);

                return missingLanguageCodes;
            },
            /**
             * Find which languages has been removed from the account supported languages  - since the last time the tabs were initialized
             * @returns {Array}
             * @private
             */
            getRemovedLanguageCodes: function(){
                var siteLanguages = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var tabLanguages = this.getLanguageTabCollection().pluck("id");
                var removedLanguageCodes = [];

                _.each(tabLanguages, function (code, index, list){
                    if(!_.contains(siteLanguages, code) && code !== KEYS.addLanguagesButton){
                        removedLanguageCodes.push(code);
                    }
                }, this);

                return removedLanguageCodes;
            },
            //site languages has been removed - remove them from the model
            deleteRemovedLanguagesData: function(removedLanguages){
                if(removedLanguages.length !== 0) {
                    var modelData = this.getModelData();
                    _.each(removedLanguages, function (code, index, list) {
                        modelData = _.reject(modelData, function (dataItem) {
                            return dataItem.lang === code;
                        });
                        if(code === this.getSelectedLanguage()){
                            this.setSelectedLanguage(this.defaultSiteLang);
                        }
                    }, this);
                    this.setModelData(modelData, {noSaveValidate: true});
                }
            },
            //site languages has been added - add to the model added data for each item if it exists
            appendAddedLanguagesData: function (modelAll, missingLanguageCodes) {
                var modelDataArr = [];
                var contextData;
                var selectedSkill = this.getSelectedSkill();
                if(DEFAULT_SKILL_NAME === selectedSkill) {
                    contextData = modelAll.getContextAccount();
                } else {
                    contextData = modelAll.getSkillContext(selectedSkill);
                }
                if(contextData) {
                    modelDataArr = contextData.data;
                }
                var missingData = _.filter(modelDataArr, function(item){
                    return _.contains(missingLanguageCodes , item.lang);
                });
                var existingModelData = this.getModelData().concat(missingData);
                this.setModelData(existingModelData, {noSaveValidate: true});
            },
            setDefaultLanguageData: function(defaultDataArr){
                //remove defaults that are not in use in the UI
                var defaultDataForAvailableLanguages = _.filter(defaultDataArr, function(item){
                    return _.contains(this.languageCodes , item.lang);
                }, this);

                var modelData = this.getModelData();
                //remove those that have defaults
                _.each(defaultDataArr, function (defaultDataForAvailableLanguages, index, list) {
                    modelData = _.reject(modelData, function (dataItem) {
                        return dataItem.lang === defaultDataForAvailableLanguages.lang;
                    });
                }, this);

                var existingModelData = modelData.concat(defaultDataForAvailableLanguages);

                this.setModelData(existingModelData);
            },

            getSelectedLanguage: function () {
                return this.getLanguageTabCollection().getSelectedId();
            },
            setSelectedLanguage: function (selectedLang) {
                this.getLanguageTabCollection().selectModel(selectedLang);
            },
            getSelectedSkill: function () {
                return this.getSkillTabCollection().getSelectedId();
            },
            setSelectedSkill: function (selectedSkill) {
                this.getSkillTabCollection().selectModel(selectedSkill);
            },
            getContentDataKey: function(){
                return this.getContentModel().getContentDataKey();
            },
            getContentMSGKey: function(){
                return this.getContentModel().getContentMSGKey(this.getSelectedLanguage());
            },
            setContentModel: function(model){
                model.setValidations();
                model.resetLanguageContentMap();
                this.stopListening(this.getContentModel());
                this.set(KEYS.saveAllowed,false);
                this.set(KEYS.contentModelHasChanges,false);
                this.set(KEYS.saveAllowedTooltipKey,model.saveNoChangesTooltip());
                this.set(KEYS.saveAllowedTooltipValue,LE.translator.translate(model.saveNoChangesTooltip()));
                this.setHeader(model.getHeaderTexts());
                this.set(KEYS.model,model);

                var info = LEContent.getDataManager().getItemIndexInfo(model,LEContent.getDataManager().getEntities().SYSTEM_MESSAGING);
                this.set(KEYS.pageInfo, {
                    previousPageNumber: info.currentPageNumber,
                    currentPageNumber:  info.currentPageNumber,
                    totalPages: info.totalPages
                });
                model.initLanguagesWithErrors();
                this.listenTo(model,"change",this._validateSaveAllowed);
                this.initLanguageTabs();
            },

            _validateSaveAllowed: function (modelChanges, options) {
                if(!(options && options.noSaveValidate)) { //no save needed for site language changes
                    //need to compute is save allowed
                    //First if we arrived here its because we listen to model change - this means costumer did some changes so save is allowed on that aspect
                    this.set(KEYS.contentModelHasChanges, true);
                    var selectedLanguage = this.getSelectedLanguage();
                    //now lets check if the model is savable
                    var modelSavableObject = this.getContentModel().validateSaveEnabled(selectedLanguage, this.languageCodes);

                    var modelSavable = modelSavableObject.isSaveValid;
                    var tooltipKey = modelSavableObject.tooltip;
                    var tooltipValue = "";

                    if (_.isString(tooltipKey) && tooltipKey.length > 0) {
                        if (!modelSavableObject.isContentValid) {
                            tooltipValue =  LE.translator.translate({
                                key: tooltipKey,
                                args: [{key: this.getTranslatedLanguagesWithErrors().join(", ")}]
                            });
                        }
                        else {
                            tooltipValue = LE.translator.translate(tooltipKey);
                        }
                    }

                    this.set(KEYS.saveAllowed, modelSavable);
                    this.set(KEYS.saveAllowedTooltipKey, tooltipKey);
                    this.set(KEYS.saveAllowedTooltipValue, tooltipValue);
                }

            },
            getIsSaveAllowedTooltipValue: function() {
                return this.get(KEYS.saveAllowedTooltipValue);
            },
            resetContentModel: function(model) {
                this.setDefaultLanguageData(model.getData());
                this.setSystemMessageTimer(model.getTimer());
                this.setSystemMessageTimerUnit(model.getTimerUnit());
            },
            validateContent: function() {
                return this.getContentModel().validateContent();
            },
            getContentModel: function(){
                return this.get(KEYS.model);
            },
            getLanguageTabCollection: function(){
                return this.get(KEYS.languageTabCollection);
            },
            getSkillTabCollection: function(){
                return this.get(KEYS.skillTabCollection);
            },
            getSelectedLanguageContentTitle: function(){
                return this.getContentModel().getContentTitle(this.getSelectedLanguage()) ;
            },
            getSelectedLanguageContentMessage: function(){
                return this.getContentModel().getContentMessage(this.getSelectedLanguage()) ;
            },
            setAllowMiniErrors: function(allowMiniErrors){
                this.set(KEYS.allowMiniErrors,allowMiniErrors);
            },
            setHeader: function(header){
                this.set(KEYS.header,header);
            },
            getHeader: function(){
                return this.get(KEYS.header);
            },
            setContentMessage: function(message){
                var selectedLanguage = this.getSelectedLanguage();
                this.getContentModel().setContentMessage(selectedLanguage,message);
                this._setHasContentFlagOnTab(selectedLanguage);
            },
            _setHasContentFlagOnTab: function(lang){
                var tabModel = this.getLanguageTabCollection().findWhere({id: lang});
                tabModel.set("hasContent",this.getContentModel().hasContent(lang));
            },
            getContentMessage: function(){
               return this.getContentModel().getContentMessage(this.getSelectedLanguage());
            },
            getEnabledState: function(){
                return this.getContentModel().getEnabledState();
            },
            setEnabledState: function(state){
                this.getContentModel().setEnabledState(state);
            },
            isEnabledEditable: function(){
                return this.getContentModel().isEnabledEditable();
            },
            hasTitleField: function() {
                return this.getContentModel().hasTitleField();
            },
            isOnHoldSystemMessage: function(){
                return this.getContentModel().isOnHoldMessage();
            },
            getSystemMessageTimer: function() {
                return this.getContentModel().getTimer();
            },
            setSystemMessageTimer: function(timer){
                this.getContentModel().setTimer(timer);
            },
            setSystemMessageTimerUnit: function(timerUnit){
                this.getContentModel().setTimerUnit(timerUnit);
            },
            getSystemEventName: function(){
                return this.getContentModel().getNameForEditPage();
            },
            hasRestoreToDefault: function(){
                return !_.isUndefined(this.getTemplateId()) && !_.isNull(this.getTemplateId()) ;
            },
            getTemplateId: function(){
                return this.getContentModel().getTemplateId();
            },
            getContentPageInfoTotal: function(){
                return this.get(KEYS.pageInfoTotals);
            },
            getContentPageInfoCurrentPage: function(){
                return this.get(KEYS.pageInfoCurrent);
            },
            getContentPageInfoPreviousPage: function(){
                return this.get(KEYS.pageInfoPrevious);
            },
            setContentPageInfoCurrentPage: function(currentPageIdx){
                this.set(KEYS.pageInfoPrevious,this.getContentPageInfoCurrentPage());
                this.set(KEYS.pageInfoCurrent,currentPageIdx);
            },
            revertContentPageNumberChange: function() {
                this.set(KEYS.pageInfoCurrent,this.getContentPageInfoPreviousPage());
            },
            getAllowedMacros: function(){
                return this.getContentModel().getAllowedMacros();
            },
            getAllContentMacros: function(){
                var systemMessagingMacros = this.onClearEmptySystemMessagingModel.getAllSystemMessagingMacros();
                return systemMessagingMacros;
            },
            hasChanges: function(){
                return this.get(KEYS.contentModelHasChanges);
            },
            getIsSaveAllowed: function(){
                return this.get(KEYS.saveAllowed);
            },
            getIsSaveAllowedTooltipKey: function(){
                return this.get(KEYS.saveAllowedTooltipKey);
            },
            getModelID: function(){
                return this.getContentModel().getID();
            },
            getType: function(){
                return this.get(KEYS.type);
            }
        });
    });

    ContentSystemMessagingEditPageModel.KEYS = KEYS;
    ContentSystemMessagingEditPageModel.CONTEXTS = CONTEXTS;
    ContentSystemMessagingEditPageModel.DEFAULT_SKILL_NAME = DEFAULT_SKILL_NAME;

    return ContentSystemMessagingEditPageModel;
});
